import ApiClient from "./../../api/src/ApiClient";
import Cms from "./../../cms/src/Cms";
import Storage from "./BannerStorage";

export default {
  namespaced: true,

  state: {
    list: []
  },

  mutations: {
    setupList(state, response) {
      for (var banner of response.list) {
        banner.banner = Cms.replaceSizePhoto(
          banner.banner,
          response.size.width,
          response.size.height
        );
      }
      state.list = response.list;
    }
  },

  actions: {
    async getList({ commit, state }, size) {
      let list = Storage.load();
      if (!list) {
        list = await ApiClient.get("api/cms/banners");
        Storage.save(list);
      }
      commit("setupList", { list: list, size: size });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/banners/src/BannerStore.js